export default "__VITE_ASSET__b3fc316c__"